import { push } from 'connected-react-router'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Sticky from 'react-sticky-el'

import {
  cancelEditingOrder,
  loadEditOrder,
  removeItemFromOrderCartStart,
} from '../../redux/modules/cart'
import { clearMenuItem } from '../../redux/modules/order'
import {
  selectCurrentLocationWithAddress,
  selectMenuItemForEdit,
} from '../../redux/modules/selectors'
import { currentUserStart } from '../../redux/modules/user'
import { checkoutRoute } from '../../routes/routes'
import { formatUrl } from '../../util/formatUtils'
import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'
import { OrderCart } from '../cart/Cart'
import { SpinnerCard } from '../common/Layout'
import { Location, LocationBuilding, LocationContainer, LocationTime } from '../common/Location'
import PersonalizeOrder from '../personalize-order/PersonalizeOrder'

export class OrderSidebar extends Component {
  constructor(props) {
    super(props)
    const { clearMenuItem } = this.props
    clearMenuItem()
    this.handleClose = this.handleClose.bind(this)
  }

  handleClose() {
    this.props.clearMenuItem()
    this.props.cancelEditingOrder()
  }
  render() {
    const {
      deliveryDropoff,
      isAuthenticated,
      isDeliveryDropoffLoading,
      isEditingOrder,
      isEditingPastOrder,
      isLocationLoading,
      isOrderCartLoading,
      loadEditOrder,
      location,
      menuItemForEdit,
      normalizedMenuItem,
      orderCart,
      orderCartError,
      push,
      removeItemFromOrderCartStart,
    } = this.props
    const disabledCheckout = !isAuthenticated
    return (
      <div className="sticky order-sidebar">
        <Sticky stickyStyle={{ paddingTop: '65px' }} topOffset={-65}>
          <SpinnerCard
            key="location"
            spinnerActive={isLocationLoading || isDeliveryDropoffLoading || isOrderCartLoading}
          >
            {!isLocationLoading && location && (
              <Location>
                <LocationContainer>
                  <LocationBuilding
                    address={location.address}
                    name={location.deliveryLocationName}
                    showLink={false}
                  />
                  <LocationTime
                    dateTime={deliveryDropoff.deliveryDateTime}
                    deliveryTimeDisplay={deliveryDropoff.dropoffDisplay}
                    multiLine={false}
                  />
                </LocationContainer>
              </Location>
            )}
            <hr />
            {orderCart && deliveryDropoff && (
              <OrderCart
                cart={orderCart}
                deleteMenuItem={removeItemFromOrderCartStart}
                dropoffId={deliveryDropoff.dropoffId}
                editable="true"
                editMenuItem={loadEditOrder}
                error={orderCartError}
                isEditingPastOrder={false}
                isInvalid={disabledCheckout}
                onCheckout={() => {
                  pushSnowplow(toOrderProcessSchema('daily', 'move_to_checkout', 'cart', null))
                  push(
                    formatUrl(checkoutRoute.path, {
                      dropoffId: deliveryDropoff.dropoffId,
                      locationId: location.deliveryLocationId,
                    }),
                  )
                }}
                showEditLinks="true"
              />
            )}
          </SpinnerCard>
          {!isEditingPastOrder && menuItemForEdit && isEditingOrder && (
            <PersonalizeOrder
              dropoffId={deliveryDropoff.dropoffId}
              handleClose={this.handleClose}
              isEditingFromCheckout={false}
              isEditingFromMenu="true"
              isEditingOrder={isEditingOrder}
              isEditingPastOrder={false}
              locationId={location.deliveryLocationId}
              menuItemForEdit={menuItemForEdit}
              menuItemId={menuItemForEdit.menuItemId}
              normalizedMenuItem={normalizedMenuItem}
            />
          )}
        </Sticky>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const { isOrderCartLoading, orderCart, orderCartError } = state.cart
  const { isAuthenticated } = state.user
  const { normalizedMenuItem } = state.personalize
  const { deliveryDropoff, isDeliveryDropoffLoading } = state.delivery
  const location = selectCurrentLocationWithAddress(state)
  const menuItemForEdit = selectMenuItemForEdit(state)
  const { isLocationLoading } = state.location
  const { isEditingOrder, isEditingPastOrder } = state.cart
  return {
    deliveryDropoff,
    isAuthenticated,
    isDeliveryDropoffLoading,
    isEditingOrder,
    isEditingPastOrder,
    isLocationLoading,
    isOrderCartLoading,
    location,
    menuItemForEdit,
    normalizedMenuItem,
    orderCart,
    orderCartError,
  }
}

const mapDispatchToProps = {
  cancelEditingOrder,
  clearMenuItem,
  currentUserStart,
  loadEditOrder,
  push,
  removeItemFromOrderCartStart,
}

export default connect(mapStateToProps, mapDispatchToProps)(OrderSidebar)
